export const SERVICES = [
  {
    id: "web",
    title: "Custom Website Development",
    desc: "Bespoke, conversion-engineered websites built on a premium tech stack — Next-gen performance, SEO foundations and an editorial visual language tailored to your brand.",
    bullets: ["Brand-led design systems", "Headless CMS & e‑commerce", "Sub-second performance"],
    icon: "Globe2",
    span: "lg:col-span-3 lg:row-span-2",
    image:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "apps",
    title: "Mobile & Web App Development",
    desc: "Native-grade iOS, Android and progressive web apps engineered for retention and revenue.",
    bullets: ["React Native & PWA", "Realtime APIs", "App Store launch"],
    icon: "Smartphone",
    span: "lg:col-span-2",
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "marketing",
    title: "Marketing & Lead Generation",
    desc: "Performance campaigns that turn Manchester locals into loyal, paying customers.",
    bullets: ["Google & Meta Ads", "Conversion funnels", "CRM automation"],
    icon: "TrendingUp",
    span: "lg:col-span-2",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "branding",
    title: "Branding & Visual Identity",
    desc: "Iconic logos, type systems and brand guidelines that command a premium price tag.",
    bullets: ["Logo & wordmarks", "Brand books", "Print & packaging"],
    icon: "Sparkles",
    span: "lg:col-span-3",
    image:
      "https://images.unsplash.com/photo-1626785774573-4b799315345d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "seo",
    title: "SEO & Local Growth Solutions",
    desc: "Rank #1 for the searches your future customers in Greater Manchester are typing right now.",
    bullets: ["Technical SEO audits", "Google Business profiles", "Local link building"],
    icon: "Search",
    span: "lg:col-span-5",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
];

export const WHY_US = [
  { icon: "Crown", title: "Premium Service", text: "White-glove project management and a dedicated strategist on every engagement." },
  { icon: "Zap", title: "Fast Delivery", text: "Sprint-based workflow delivers production-grade work in weeks — not quarters." },
  { icon: "Palette", title: "Modern Design", text: "Editorial, animation-forward UI that signals quality before a single word is read." },
  { icon: "MapPin", title: "Manchester Expertise", text: "Born and built in M-town. We know the high streets, the customers and the culture." },
  { icon: "BarChart3", title: "ROI-Focused", text: "Every pixel, page and pound is measured against revenue. Vanity metrics need not apply." },
  { icon: "LifeBuoy", title: "Ongoing Support", text: "Care plans, monthly reporting and a real human on WhatsApp when it matters." },
];

export const PORTFOLIO = [
  {
    id: 1,
    category: "Restaurants",
    title: "Salt & Ember",
    summary: "A flagship dining experience in the Northern Quarter — reservations up 312%.",
    image:
      "https://images.unsplash.com/photo-1744776411214-31209006a0f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: 2,
    category: "Estate Agents",
    title: "Halcyon Residences",
    summary: "Luxury property portal for a boutique Cheshire agency — 5x qualified viewings.",
    image:
      "https://images.unsplash.com/photo-1756435292384-1bf32eff7baf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: 3,
    category: "Salons",
    title: "Maison Argent",
    summary: "Editorial salon brand with online booking — fully booked 6 weeks in advance.",
    image:
      "https://images.unsplash.com/photo-1759142235060-3191ee596c81?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: 4,
    category: "Retail",
    title: "Atelier No. 9",
    summary: "Independent boutique e‑commerce — average order value lifted 41%.",
    image:
      "https://images.unsplash.com/photo-1768612351259-74ed582fc3ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: 5,
    category: "Gyms",
    title: "Iron & Oak Athletic",
    summary: "Premium private gym with member portal and class booking app.",
    image:
      "https://images.unsplash.com/photo-1729156638758-6fa6405b289b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: 6,
    category: "Tradesmen",
    title: "Whitfield Joinery",
    summary: "Heritage craftsman site that turned £8 leads into £40k commissions.",
    image:
      "https://images.unsplash.com/photo-1698768194564-bd8ac2f4ea94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const TESTIMONIALS = [
  {
    name: "Olivia Harrington",
    role: "Founder, Salt & Ember",
    location: "Northern Quarter, Manchester",
    quote:
      "Acnira didn't just build us a website — they built a brand worthy of a Michelin nod. Reservations doubled in the first month.",
    initials: "OH",
  },
  {
    name: "James Whitworth",
    role: "Director, Halcyon Residences",
    location: "Wilmslow, Cheshire",
    quote:
      "The portal is gorgeous and, more importantly, it sells. We closed two seven-figure listings within the first quarter.",
    initials: "JW",
  },
  {
    name: "Priya Shah",
    role: "Owner, Maison Argent",
    location: "Didsbury, Manchester",
    quote:
      "Every detail feels considered. Clients comment on the booking experience before they've even sat in the chair.",
    initials: "PS",
  },
  {
    name: "Marcus Thornton",
    role: "Co-Founder, Iron & Oak Athletic",
    location: "Ancoats, Manchester",
    quote:
      "Premium positioning, premium results. Membership enquiries jumped 220% in eight weeks.",
    initials: "MT",
  },
];

export const STATS = [
  { value: "120+", label: "Manchester businesses launched" },
  { value: "98%", label: "Client retention rate" },
  { value: "4.9", label: "Average client satisfaction" },
  { value: "24h", label: "Average response time" },
];

export const FAQS = [
  {
    q: "How quickly can you launch a new website?",
    a: "A bespoke marketing site typically takes 4–6 weeks from kickoff. Apps and e‑commerce platforms run 8–14 weeks, depending on scope.",
  },
  {
    q: "Do you only work with Manchester businesses?",
    a: "Manchester and Greater Manchester are our home turf, but we work across the UK. Local businesses get the bonus of in-person workshops at our Ancoats studio.",
  },
  {
    q: "What's the typical investment for a project?",
    a: "Bespoke websites start at £6,000. Full brand and digital launches range from £12,000–£40,000+. We tailor every proposal to your goals and ROI.",
  },
  {
    q: "Do you offer ongoing support and maintenance?",
    a: "Yes. Our care plans cover hosting, security, monthly reporting, and a dedicated success manager. WhatsApp access included.",
  },
];
